import { render, staticRenderFns } from "./LeadStatus.vue?vue&type=template&id=b6ff5816&"
import script from "./LeadStatus.vue?vue&type=script&lang=js&"
export * from "./LeadStatus.vue?vue&type=script&lang=js&"
import style0 from "./LeadStatus.vue?vue&type=style&index=0&id=b6ff5816&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports